var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlurIconActiveBigger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 12.5C15.3334 15.4455 12.9456 17.8333 10.0001 17.8333C7.05456 17.8333 4.66675 15.4455 4.66675 12.5C4.66675 11.7816 4.90382 10.7667 5.3147 9.61628C5.72152 8.4772 6.28333 7.24718 6.89797 6.11348C7.51369 4.97778 8.17384 3.95462 8.77249 3.2229C9.07272 2.85592 9.34594 2.57655 9.57945 2.39343C9.82917 2.19761 9.96443 2.16663 10.0001 2.16663C10.0357 2.16663 10.171 2.19761 10.4207 2.39343C10.6542 2.57655 10.9274 2.85592 11.2277 3.2229C11.8263 3.95462 12.4865 4.97778 13.1022 6.11348C13.7168 7.24718 14.2786 8.4772 14.6855 9.61628C15.0963 10.7667 15.3334 11.7816 15.3334 12.5Z",
    stroke: "#0E0333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.8333C11.6667 15.8333 13.3333 14.1667 13.3333 12.5",
    stroke: "#0E0333",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurIconActiveBigger);
export default __webpack_public_path__ + "static/media/blur-icon-active-bigger.7a6b1658d715bd43c5355d2fcceb3207.svg";
export { ForwardRef as ReactComponent };